import { Colors } from '@lichtblick/theme';

import { StyledSeparator } from './Separator.styles';

type SeparatorProps = {
  color?: string;
  isDecorative?: boolean;
  orientation: 'horizontal' | 'vertical';
};

export const Separator = ({ color = Colors.blue[20], isDecorative, orientation }: SeparatorProps) => {
  return <StyledSeparator color={color} decorative={isDecorative} orientation={orientation} />;
};
